import { TDOWNLOAD_LISTING_DATA_PAYLOAD, TExcelContext } from '@monorepo/types';
import { TUploadResponseDTO } from '@monorepo/services';
import { Action } from '@ngrx/store';
import { TExcelManagementActionType } from './excel-management.models';

export class UploadExcel implements Action {
  readonly type = TExcelManagementActionType.UploadExcel;
  constructor(
    public payload: {
      file: File;
      excelContext: TExcelContext;
    },
  ) {}
}

export class UploadExcelSuccess implements Action {
  readonly type = TExcelManagementActionType.UploadExcelSuccess;
}

export class UploadExcelFailure implements Action {
  readonly type = TExcelManagementActionType.UploadExcelFailure;
}

export class DownloadExcel implements Action {
  readonly type = TExcelManagementActionType.DownloadExcel;
  constructor(public excelContext: TExcelContext) {}
}

export class DownloadExcelSuccess implements Action {
  readonly type = TExcelManagementActionType.DownloadExcelSuccess;
  constructor() {}
}

export class DownloadExcelFailure implements Action {
  readonly type = TExcelManagementActionType.DownloadExcelFailure;
}

export class DownloadListingDataExcel implements Action {
  readonly type = TExcelManagementActionType.DownloadListingDataExcel;
  constructor(public excelContext: TExcelContext, public payload: Omit<TDOWNLOAD_LISTING_DATA_PAYLOAD, 'factoryId'>) {}
}

export class DownloadListingDataExcelSuccess implements Action {
  readonly type = TExcelManagementActionType.DownloadListingDataExcelSuccess;
  constructor() {}
}

export class DownloadListingDataExcelFailure implements Action {
  readonly type = TExcelManagementActionType.DownloadListingDataExcelFailure;
}

export class DownloadErrorExcel implements Action {
  readonly type = TExcelManagementActionType.DownloadErrorExcel;
  constructor(
    public payload: {
      errorKey: Exclude<TUploadResponseDTO['errorFileKeyOpt'], undefined>;
      excelContext: TExcelContext;
    },
  ) {}
}

export class DownloadErrorExcelSuccess implements Action {
  readonly type = TExcelManagementActionType.DownloadExcelErrorSuccess;
}

export class DownloadErrorExcelFailure implements Action {
  readonly type = TExcelManagementActionType.DownloadExcelErrorFailure;
}

export type TExcelManagementActions =
  | UploadExcel
  | UploadExcelSuccess
  | UploadExcelFailure
  | DownloadExcel
  | DownloadExcelSuccess
  | DownloadExcelFailure
  | DownloadErrorExcel
  | DownloadErrorExcelSuccess
  | DownloadErrorExcelFailure
  | DownloadListingDataExcel
  | DownloadListingDataExcelSuccess
  | DownloadListingDataExcelFailure;
